import { render, staticRenderFns } from "./video-edit.vue?vue&type=template&id=ac47f05a&scoped=true&"
import script from "./video-edit.vue?vue&type=script&lang=js&"
export * from "./video-edit.vue?vue&type=script&lang=js&"
import style0 from "./video-edit.vue?vue&type=style&index=0&id=ac47f05a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac47f05a",
  null
  
)

export default component.exports